import React from 'react';

// Friendly empty state: gold icon, one short line
export const EmptyState = ({ icon: Icon, title, line, action, testId, className = '' }) => (
  <div
    className={`bd-card bd-card-accent bd-fade-up px-6 py-10 text-center ${className}`}
    data-testid={testId}
  >
    {Icon && (
      <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-cream">
        <Icon className="h-7 w-7 text-gold-deep" />
      </div>
    )}
    {title && <h3 className="bd-heading text-base text-ink">{title}</h3>}
    {line && <p className="mt-2 text-sm text-slate-500">{line}</p>}
    {action && <div className="mt-5 flex justify-center">{action}</div>}
  </div>
);

export default EmptyState;
